import type { AccountInfoData } from "~/features/b2bAccountSelection/components/AccountSelectionTabelView/api/GetAccountList";
import { useEffect, useMemo, useState } from "react";
import AccountSelectionGrid from "~/features/b2bAccountSelection/components/AccountSelectionView/components/AccountSelectionGrid";
import AccountSelectionSearch from "~/features/b2bAccountSelection/components/AccountSelectionView/components/AccountSelectionSearch";
import { AccountSelectionBottomButton, setAccount } from "~/pages/AccountSelectionPage/AccountSelectionPage";
import { useIsMinDesktopSize } from "~/common/hooks/useMediaQuery";
import { useTranslation } from "react-i18next";

interface NewAccountSelectionGridProps {
  accounts: AccountInfoData[];
  selectedAccountId: string;
  className?: string;
}

const NewAccountSelectionGrid = ({ accounts, selectedAccountId, className }: NewAccountSelectionGridProps) => {
  const { t } = useTranslation();
  const [value, setValue] = useState("");
  const [selectedAccount, setSelectedAccount] = useState<AccountInfoData | undefined>();

  useEffect(() => {
    setSelectedAccount(accounts.find((account) => account.id === selectedAccountId));
  }, [accounts, selectedAccountId]);

  const filteredAccounts = useMemo(() => {
    if (!accounts) {
      return [];
    }

    return accounts.filter((account) => {
      const query = value.toLowerCase();
      const filteredValue = `${account.name}-${account.number}`.toLowerCase();
      return filteredValue.includes(query);
    });
  }, [accounts, value]);

  const buttonDisabled =
    filteredAccounts.findIndex((account) => account === selectedAccount) === -1 || !selectedAccount;

  const isDesktop = useIsMinDesktopSize();

  const handleAccountChange = () => setAccount(selectedAccount!.uid, selectedAccount?.salesOrg);

  const handleOnAccountClick = (account: AccountInfoData) => {
    setSelectedAccount(account);
    if (isDesktop) {
      setAccount(account.uid, account.salesOrg);
      window.sessionStorage.removeItem("orderbookSearchData");
      window.sessionStorage.removeItem("orderHistorySearchData");
    }
  };

  return (
    <>
      <AccountSelectionSearch value={value} onChange={(e) => setValue(e.target.value)} />
      <AccountSelectionGrid
        selectedAccount={selectedAccount}
        onAccountClick={handleOnAccountClick}
        accounts={filteredAccounts}
      />

      {!isDesktop && <AccountSelectionBottomButton onClick={handleAccountChange} disabled={buttonDisabled} />}
    </>
  );
};

export default NewAccountSelectionGrid;
